import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-brand">
              <h3>⚡ Enerji Takip</h3>
              <p>Türkiye'nin lider enerji yönetimi ve akıllı şebeke çözümleri sağlayıcısı. 2015'ten beri 50+ şehirde hizmet veriyoruz.</p>
            </div>
            <div className="footer-contact">
              <h4>İletişim Bilgileri</h4>
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <span>Maslak Mahallesi, Büyükdere Caddesi No:123/A, 34485 Sarıyer/İstanbul</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <span>+90 212 555 0123</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📧</span>
                <span>info@enerjitakip.com</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">🌐</span>
                <span>www.enerjitakip.com</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Hızlı Erişim</h4>
            <div className="footer-links">
              <Link to="/homepage">Anasayfa</Link>
              <Link to="/features">Özellikler</Link>
              <Link to="/guide">Kullanım Rehberi</Link>
              <Link to="/devices">Desteklenen Cihazlar</Link>
              <Link to="/references">Referanslar</Link>
              <Link to="/dashboard">Dashboard</Link>
              <Link to="/analytics">Analitikler</Link>
              <Link to="/settings">Ayarlar</Link>
            </div>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4>Hizmetlerimiz</h4>
            <div className="footer-links">
              <Link to="/features">Akıllı Şebeke Çözümleri</Link>
              <Link to="/features">Enerji Denetimi</Link>
              <Link to="/features">IoT Sensör Sistemleri</Link>
              <Link to="/analytics">Veri Analizi</Link>
              <Link to="/features">Danışmanlık</Link>
              <Link to="/guide">Eğitim Programları</Link>
              <Link to="/guide">Teknik Destek</Link>
              <Link to="/guide">Bakım Hizmetleri</Link>
            </div>
          </div>

          {/* Legal & Compliance */}
          <div className="footer-section">
            <h4>Yasal & Uyumluluk</h4>
            <div className="footer-links">
              <Link to="/guide">Gizlilik Politikası</Link>
              <Link to="/guide">Kullanım Şartları</Link>
              <Link to="/guide">Veri Koruma</Link>
              <Link to="/guide">Çerez Politikası</Link>
              <Link to="/guide">GDPR Uyumluluk</Link>
              <Link to="/guide">Erişilebilirlik</Link>
              <Link to="/guide">Sürdürülebilirlik</Link>
              <Link to="/guide">Etik Kurallar</Link>
            </div>
          </div>
        </div>

        {/* Certifications & Awards */}
        <div className="footer-certifications">
          <h4>🏆 Sertifikalar & Ödüller</h4>
          <div className="certifications-grid">
            <div className="cert-item">
              <div className="cert-logo">🏅</div>
              <div className="cert-info">
                <h5>ISO 9001:2015</h5>
                <p>Kalite Yönetim Sistemi</p>
              </div>
            </div>
            <div className="cert-item">
              <div className="cert-logo">⚡</div>
              <div className="cert-info">
                <h5>ISO 50001:2018</h5>
                <p>Enerji Yönetim Sistemi</p>
              </div>
            </div>
            <div className="cert-item">
              <div className="cert-logo">🔒</div>
              <div className="cert-info">
                <h5>ISO 27001:2013</h5>
                <p>Bilgi Güvenliği Yönetimi</p>
              </div>
            </div>
            <div className="cert-item">
              <div className="cert-logo">🌱</div>
              <div className="cert-info">
                <h5>ISO 14001:2015</h5>
                <p>Çevre Yönetim Sistemi</p>
              </div>
            </div>
            <div className="cert-item">
              <div className="cert-logo">🏭</div>
              <div className="cert-info">
                <h5>ISO 45001:2018</h5>
                <p>İş Sağlığı ve Güvenliği</p>
              </div>
            </div>
            <div className="cert-item">
              <div className="cert-logo">💼</div>
              <div className="cert-info">
                <h5>CE Marking</h5>
                <p>Avrupa Uygunluk İşareti</p>
              </div>
            </div>
            <div className="cert-item">
              <div className="cert-logo">🇹🇷</div>
              <div className="cert-info">
                <h5>TSE Marka</h5>
                <p>Türk Standardları Enstitüsü</p>
              </div>
            </div>
            <div className="cert-item">
              <div className="cert-logo">🏆</div>
              <div className="cert-info">
                <h5>Teknoloji Ödülü 2024</h5>
                <p>T.C. Sanayi ve Teknoloji Bakanlığı</p>
              </div>
            </div>
          </div>
        </div>

        {/* Regulatory Approvals */}
        <div className="footer-regulatory">
          <h4>🏛️ Resmi Onaylar & Lisanslar</h4>
          <div className="regulatory-grid">
            <div className="reg-item">
              <div className="reg-logo">⚡</div>
              <div className="reg-info">
                <h5>Enerji Piyasası Düzenleme Kurumu (EPDK)</h5>
                {/* <p>Lisans No: EPDK-2023-001234</p> */}
                <span className="reg-status">Aktif</span>
              </div>
            </div>
            <div className="reg-item">
              <div className="reg-logo">🏛️</div>
              <div className="reg-info">
                <h5>T.C. Enerji ve Tabii Kaynaklar Bakanlığı</h5>
                {/* <p>Onay No: ETK-2024-567890</p> */}
                <span className="reg-status">Onaylı</span>
              </div>
            </div>
            <div className="reg-item">
              <div className="reg-logo">🏭</div>
              <div className="reg-info">
                <h5>T.C. Sanayi ve Teknoloji Bakanlığı</h5>
                {/* <p>Ar-Ge Desteği: SANTEK-2024-001</p> */}
                <span className="reg-status">Destekleniyor</span>
              </div>
            </div>
            <div className="reg-item">
              <div className="reg-logo">🌍</div>
              <div className="reg-info">
                <h5>Avrupa Birliği Horizon 2024</h5>
                {/* <p>Proje No: EU-H2024-SMART-001</p> */}
                <span className="reg-status">Fonlanıyor</span>
              </div>
            </div>
          </div>
        </div>

        {/* Technology Partners */}
        <div className="footer-partners">
          <h4>🤝 Teknoloji Ortaklarımız</h4>
          <div className="partners-grid">
            <div className="partner-item">
              <div className="partner-logo">🔧</div>
              <span>Schneider Electric</span>
            </div>
            <div className="partner-item">
              <div className="partner-logo">⚡</div>
              <span>Siemens</span>
            </div>
            <div className="partner-item">
              <div className="partner-logo">🏢</div>
              <span>ABB</span>
            </div>
            <div className="partner-item">
              <div className="partner-logo">📡</div>
              <span>Huawei</span>
            </div>
            <div className="partner-item">
              <div className="partner-logo">🌐</div>
              <span>Cisco</span>
            </div>
            <div className="partner-item">
              <div className="partner-logo">☁️</div>
              <span>Microsoft Azure</span>
            </div>
            <div className="partner-item">
              <div className="partner-logo">☁️</div>
              <span>Amazon AWS</span>
            </div>
            <div className="partner-item">
              <div className="partner-logo">🔍</div>
              <span>IBM Watson</span>
            </div>
            <div className="partner-item">
              <div className="partner-logo">🎓</div>
              <span>İTÜD Enerji Enstitüsü</span>
            </div>
          </div>
        </div>

        {/* Statistics */}
        <div className="footer-stats">
          <h4>📊 Başarı Rakamlarımız</h4>
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">15+</div>
              <div className="stat-label">Yıllık Deneyim</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">50+</div>
              <div className="stat-label">Şehir</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">1000+</div>
              <div className="stat-label">Müşteri</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">500+</div>
              <div className="stat-label">Proje</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">%99.9</div>
              <div className="stat-label">Uptime</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Destek</div>
            </div>
          </div>
        </div>

        {/* Social Media & Newsletter */}
        <div className="footer-social">
          <div className="social-section">
            <h4>📱 Sosyal Medya</h4>
            <div className="social-links">
              <a href="#" className="social-link">
                <span className="social-icon">📘</span>
                <span>Facebook</span>
              </a>
              <a href="#" className="social-link">
                <span className="social-icon">🐦</span>
                <span>Twitter</span>
              </a>
              <a href="#" className="social-link">
                <span className="social-icon">💼</span>
                <span>LinkedIn</span>
              </a>
              <a href="#" className="social-link">
                <span className="social-icon">📷</span>
                <span>Instagram</span>
              </a>
              <a href="#" className="social-link">
                <span className="social-icon">📺</span>
                <span>YouTube</span>
              </a>
            </div>
          </div>
          
          <div className="newsletter-section">
            <h4>📧 Bülten Aboneliği</h4>
            <p>Enerji teknolojilerindeki son gelişmeleri takip edin</p>
            <div className="newsletter-form">
              <input type="email" placeholder="E-posta adresiniz" className="newsletter-input" />
              <button className="newsletter-button">Abone Ol</button>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; 2026 Enerji Takip Teknoloji A.Ş. Tüm hakları saklıdır.</p>
              <p>Merkez: İstanbul | Sermaye: 50.000.000 TL | Mersis No: 0123456789012345</p>
              <p>Vergi Dairesi: Sarıyer VD | Vergi No: 1234567890 | Ticaret Sicil No: 123456</p>
            </div>
            <div className="footer-bottom-links">
              <Link to="/guide">Yasal Uyarı</Link>
              <Link to="/guide">Sorumluluk Reddi</Link>
              <Link to="/homepage">Site Haritası</Link>
              <Link to="/homepage">İletişim</Link>
            </div>
          </div>
          <div className="footer-security">
            <div className="security-badges">
              <div className="security-badge">
                <span className="badge-icon">🔒</span>
                <span>SSL Güvenli</span>
              </div>
              <div className="security-badge">
                <span className="badge-icon">🛡️</span>
                <span>GDPR Uyumlu</span>
              </div>
              <div className="security-badge">
                <span className="badge-icon">✅</span>
                <span>ISO Sertifikalı</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

